const errorCode = {
	existingResource: '409',
};

export { errorCode };



// WEBPACK FOOTER //
// ./src/common/constants/errorStatusCodeConstants.js